import SecretsPage from './secretsPage';
export default SecretsPage;
